/**
 * Pave API
 * Pave API Documentation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ApiRequestMockFirehose } from '../model/models';
import { ApiResponseSuccessModel } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface SentianceServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * More Info: https://docs.sentiance.com/guide/firehose Needed for verification by sentiance
     * 
     */
    sentianceControllerFirehoseGet0(extraHttpRequestParams?: any): Observable<object>;

    /**
     * More Info: https://docs.sentiance.com/guide/firehose Needed for verification by sentiance
     * 
     */
    sentianceControllerFirehoseGet1(extraHttpRequestParams?: any): Observable<object>;

    /**
     * 
     * 
     */
    sentianceControllerFirehosePost0(extraHttpRequestParams?: any): Observable<ApiResponseSuccessModel>;

    /**
     * 
     * 
     */
    sentianceControllerFirehosePost1(extraHttpRequestParams?: any): Observable<ApiResponseSuccessModel>;

    /**
     * 
     * 
     */
    sentianceControllerGetAuthCode0(extraHttpRequestParams?: any): Observable<string>;

    /**
     * 
     * 
     */
    sentianceControllerGetAuthCode1(extraHttpRequestParams?: any): Observable<string>;

    /**
     * 
     * 
     * @param apiRequestMockFirehose 
     */
    sentianceControllerMockFirehose0(apiRequestMockFirehose: ApiRequestMockFirehose, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * 
     * 
     * @param apiRequestMockFirehose 
     */
    sentianceControllerMockFirehose1(apiRequestMockFirehose: ApiRequestMockFirehose, extraHttpRequestParams?: any): Observable<{}>;

}
